import {API} from "../../../api/api";
import {RTPProfilesAPIRoutes} from "./apiRoutes";

const getProfiles = () =>
    API.request({
        routeID: RTPProfilesAPIRoutes.GET_PROFILES,
        odataParameters: {
            skip: 0,
            top: 10000,
            orderby: "version_number"
        }
    });

const getSubsidiaries = () =>
    API.request({
        routeID: RTPProfilesAPIRoutes.GET_SUBSIDIARIES,
        odataParameters: {
            skip: 0,
            top: 10000,
            orderby: "description"
        }
    });

const createProfile = profile =>
    API.request({
        routeID: RTPProfilesAPIRoutes.CREATE_PROFILE,
        parameters: {
            version_string: profile.version_string,
            version_number: profile.version_number,
            aggregator_string: profile.aggregator_string,
            rtp: profile.rtp
        },
        formData: false
    });

const editProfile = (profileId, profile) =>
    API.request({
        routeID: RTPProfilesAPIRoutes.EDIT_PROFILE,
        routeParameters: {profile_id: profileId},
        parameters: {
            version_string: profile.version_string,
            version_number: profile.version_number,
            aggregator_string: profile.aggregator_string,
            rtp: profile.rtp
        },
        formData: false
    });

const setDefaultProfile = (profileId, subsidiaryId) =>
    API.request({
        routeID: RTPProfilesAPIRoutes.SET_DEFAULT_PROFILE,
        routeParameters: {
            profile_id: profileId,
            subsidiary_id: subsidiaryId
        }
    });

const removeDefaultProfile = (profileId, subsidiaryId) =>
    API.request({
        routeID: RTPProfilesAPIRoutes.REMOVE_DEFAULT_PROFILE,
        routeParameters: {
            profile_id: profileId,
            subsidiary_id: subsidiaryId
        }
    });

export const rtpProfilesAPI = {
    getProfiles,
    getSubsidiaries,
    createProfile,
    editProfile,
    setDefaultProfile,
    removeDefaultProfile
};
